<template>
  <nav
    v-if="selectedNeighborhoodIds && selectedNeighborhoodIds.length"
    aria-label="Breadcrumb"
    class="breadcrumb mobhide"
  >
    <a
      :class="[{ 'pointer-none': isKioskMode }, 'breadcrumb-item']"
      @click="!isKioskMode && breadCrumbsNavigation(communitiesUrl)"
    >
      Communities<span></span>
    </a>
    <a
      v-if="communityName && isCommunityLinkActive"
      :class="[{ 'pointer-none': isKioskMode }, 'breadcrumb-item']"
      @click="!isKioskMode && breadCrumbsNavigation(communityUrl)"
    >
      {{ communityName }}
    </a>
    <p v-else-if="communityName" class="breadcrumb-item not-clickable">{{ communityName }}</p>
    <a
      v-if="selectedNeighborhoodData.neighborhood_name"
      class="breadcrumb-item"
      @click="
        !isKioskMode &&
          breadCrumbsNavigation(selectedNeighborhoodData.neighborhood_url)
      "
    >
      {{ selectedNeighborhoodData.neighborhood_name }}
    </a>
    <span class="breadcrumb-item">Home Sites</span>
  </nav>

  <nav v-else-if="communitiesUrl" aria-label="Breadcrumb" class="breadcrumb mobhide">
    <a
      :class="[{ 'pointer-none': isKioskMode }, 'breadcrumb-item']"
      @click="!isKioskMode && breadCrumbsNavigation(communitiesUrl)"
    >
      Communities
    </a>
    <a
      v-if="communityName && isCommunityLinkActive"
      :class="[{ 'pointer-none': isKioskMode }, 'breadcrumb-item']"
      @click="!isKioskMode && breadCrumbsNavigation(communityUrl)"
    >
      {{ communityName }}
    </a>
    <p v-else-if="communityName" class="breadcrumb-item not-clickable">{{ communityName }}</p>
    <span class="breadcrumb-item">Home Sites</span>
  </nav>
</template>

<script lang="ts" setup>
import { ref, watch, onMounted, toRefs, computed } from 'vue';
import type { Sibling } from '@/types';

interface Props {
  areaUrl?: string;
  communityUrl?: string;
  communityName?: string;
  communityEnabled?: boolean | string;
  isKioskMode: boolean;
  neighborhoods?: Sibling[];
  selectedNeighborhoodIds: string[];
}

const props = withDefaults(defineProps<Props>(), {
  neighborhoods: () => [] as Sibling[],
});
const {
  areaUrl,
  communityUrl,
  communityName,
  communityEnabled,
  isKioskMode,
  neighborhoods,
  selectedNeighborhoodIds,
} = toRefs(props);

const selectedNeighborhoodData = ref<Sibling>({} as Sibling);

// API serialises community_enabled as a string ("true" / "false" / ""), so "false" must not be treated as truthy
const isCommunityLinkActive = computed(
  () => String(communityEnabled?.value) === 'true' && !!communityUrl?.value
);

// Fall back to community_url until the API exposing area_url is deployed
const communitiesUrl = computed(() => areaUrl?.value || communityUrl?.value || '');

watch([neighborhoods, selectedNeighborhoodIds], () => {
  setNeighborhoodInfo();
}, {
  deep: true
});

onMounted(() => {
  setNeighborhoodInfo();
});

const setNeighborhoodInfo = () => {
  if (selectedNeighborhoodIds.value.length) {
    const neighborhood = neighborhoods.value.find(
      (n) => n.id === selectedNeighborhoodIds.value[0]
    );
    selectedNeighborhoodData.value = neighborhood ?? ({} as Sibling);
  } else {
    selectedNeighborhoodData.value = {} as Sibling;
  }
};

const breadCrumbsNavigation = (path = '') => {
  if (path) window.open(path, '_blank');
};
</script>

<style lang="scss" scoped>
.not-clickable {
  @include font(10px, 400);
  pointer-events: none;
  color: $white;
}
</style>
